import { InMemoryCache, makeVar } from "@apollo/client";
import { PlayerSkillLabel, PlayerSkillCustomLabel } from "../contract/pam.js";
class ApolloClientInMemoryCache {
  init() {
    return new InMemoryCache({
      typePolicies: {
        ...this.getUserProfileTypePolicy()
      },
      resultCaching: false
    });
  }
  getUserProfileTypePolicy() {
    const playerSecuritySummaryVar = makeVar({
      player_skill: {
        custom_label: PlayerSkillCustomLabel.Vip,
        score: 0.2,
        label: PlayerSkillLabel.Pro
      },
      gto_score: 75
    });
    return {
      UserProfile: {
        fields: {
          security: {
            read() {
              return playerSecuritySummaryVar();
            }
          }
        }
      }
    };
  }
}
export {
  ApolloClientInMemoryCache
};
//# sourceMappingURL=apolloClientInMemoryCache.js.map
